import { WidgetTaboolaAd } from './widgetTaboolaAd';

const props = [
    'height',
    'width',
    'position'
];

export const WidgetTaboolaAdDirective = reactDirective => reactDirective(WidgetTaboolaAd, props);
WidgetTaboolaAdDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('widgetTaboolaAd', WidgetTaboolaAdDirective);
